import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { NotFound } from "navigation/NotFound";
import {
  ROUTE_LOGIN,
  ROUTE_DASHBOARD,
  ROUTE_PROFILE,
  ROUTE_USERS,
  ROUTE_IMAGE_LIST,
  ROUTE_VIDEO_LIST,
  ROUTE_RECIPE_LIST,
  ROUTE_SHOP_PRODUCT_LIST,
  ROUTE_SHOP_CATEGORY_LIST,
  ROUTE_SHOP_ORDER_LIST,
  ROUTE_SETTINGS,
} from "navigation/CONSTANTS";
import PrivateRoute from "./Auth/PrivateRoute";
import LoginPage from "pages/LoginPage/LoginPage";
import TopbarLayout from "layouts/TopbarLayout/TopbarLayout";
import DashboardPage from "pages/DashboardPage/Dashboard";
import SidebarLayout from "layouts/SidebarLayout/SidebarLayout";
import { useDispatch, useSelector } from "react-redux";
import { ChangeSize } from "redux/actions/appActions";
import MainLayout from "layouts/MainLayout/MainLayout";
import UsersPage from "pages/UsersPage/UsersPage";
import UserProfilePage from "pages/ProfilePage/UserProfile/UserProfilePage";
import ImageListPage from "pages/ImageListPage/ImageListPage";
import VideoListPage from "pages/VideoListPage/VideoListPage";
import RecipeListPage from "pages/RecipeListPage/RecipeListPage";
import ShopProductListPage from "pages/ShopProductListPage/ShopProductListPage";
import ShopCategoryListPage from "pages/ShopCategoryListPage/ShopCategoryListPage";
import ShopOrderListPage from "pages/ShopOrderListPage/ShopOrderListPage";
import SettingsPage from "pages/SettingsPage/SettingsPage";


export const RouterConfig = () => {
  const screenSize = useWindowSize();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(ChangeSize({ width: screenSize.width, height: screenSize.height }))
  }, [screenSize]);
  const userDataStore = useSelector(x => x.userDataStore);
  const userInfo = userDataStore.user;
  return (
    <div>
      <Switch>
        <Route exact path={ROUTE_LOGIN} component={LoginPage} />
        <Route exact path={"/"} component={LoginPage} />

        <SidebarLayout>
          <TopbarLayout>
            <MainLayout>
              <Switch>
                <PrivateRoute
                  exact
                  path={ROUTE_DASHBOARD}
                  component={DashboardPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_IMAGE_LIST}
                  component={ImageListPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_VIDEO_LIST}
                  component={VideoListPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_RECIPE_LIST}
                  component={RecipeListPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_SHOP_PRODUCT_LIST}
                  component={ShopProductListPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_SHOP_CATEGORY_LIST}
                  component={ShopCategoryListPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_SHOP_ORDER_LIST}
                  component={ShopOrderListPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_SETTINGS}
                  component={SettingsPage}
                />
                <PrivateRoute
                  exact
                  path={ROUTE_PROFILE}
                  component={UserProfilePage}
                />
                {userInfo !== undefined && userInfo.role === "1" && <PrivateRoute
                  exact
                  path={ROUTE_USERS}
                  component={UsersPage}
                />}

                {/* List a generic 404-Not Found route here */}
                <Route path="*" component={NotFound} />
              </Switch>
            </MainLayout>
          </TopbarLayout>
        </SidebarLayout>


      </Switch>

    </div>
  );
};




// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}
